const DRIVER_ELIGIBILITY_RULE_FIELDS = `
  minAge
  maxAge
  minLicenceYears
  maxAdditionalDrivers
`;

/**
 * Fields read for the Driver Eligibility tab, by `getDriverEligibilitySettings` and `setDriverEligibilitySettings`.
 * Groups carry only their id: names come from the group list the tab loads.
 */
export const DRIVER_ELIGIBILITY_SETTINGS_QUERY = `
  mode
  system { ${DRIVER_ELIGIBILITY_RULE_FIELDS} }
  groupRules {
    groups { id }
    ${DRIVER_ELIGIBILITY_RULE_FIELDS}
  }
`;
